(function () {
    function mainCode($) {
        if (document.querySelector(".is-look-page")) {
            $(".public-hotspot-info").each(function () {
                var pid = $(this).data("pid");
                var translatedText = $(".public-hotspot-info__second-line", $(this)).text();

                $('a[data-pid="' + pid + '"]').text(translatedText);
            });
        }

        function extractHandle(href) {
            return href.replace(/[A-Za-z0-9\:\/_\.\-]*products\/([\%A-Za-z0-9_\-]+)[\?\=\&A-Za-z0-9_\/\-]*/g, "$1");
        }

        $(".tooltip_attr_name > a").each(function () {
            var textEl = $(this);
            var productPid = $(this).data("pid");
            var url = "https://" + location.host + window.Shopify.routes.root + "products/" + extractHandle($(this).attr("href")) + ".json";

            $.get(url).done(function(response) {
                var text = response.product.title;
                textEl.text(text);

                $(".public-hotspot-info__second-line", '.public-hotspot-info[data-pid="' + productPid + '"]').text(text);
            });
        });
    }

    function getRoot() {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root != '/') {
            return window.Shopify.routes.root.replace(/^\/|\/$/g, '');
        }
    }

    function waitUntilDefined() {
        if (typeof jQueryShoppable !== "undefined" && document.querySelector(".tooltip_attr_name") !== null) {
            if (getRoot()) {
                mainCode(jQueryShoppable);
            }
        } else {
            setTimeout(waitUntilDefined, 400);
        }
    }

    waitUntilDefined();
})();